import { Component, DestroyRef, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '@/app/footer/footer.component';
import { NavigationComponent } from '@/app/navigation/navigation.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BreakpointQuery } from '@/model/breakpoint-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-unauth-layout-component',
  imports: [RouterOutlet, FooterComponent, NavigationComponent],
  templateUrl: './unauth-layout-component.component.html',
  styleUrl: './unauth-layout-component.component.scss',
  standalone: true,
})
export class UnauthLayoutComponentComponent implements OnInit {
  title = 'Sondis';

  isMobileView: boolean | undefined;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.breakpointObserver
      .observe(BreakpointQuery.Compact)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => (this.isMobileView = state.matches));
  }
}
